package com.essntl.uikit.components.chat.message

import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun EsMessageReaction(
    message: MessageUiState,
    modifier: Modifier = Modifier,
) {
    val reactions = message.reactions.filter { it.emoji != null }.groupBy { it.emoji }

    Box(
        modifier = modifier
            .border(
                width = 1.dp,
                color = MaterialTheme.esColorScheme.bgPrimary,
                shape = RoundedCornerShape(20.dp),
            )
            .padding(horizontal = 10.dp, vertical = 5.dp)
            .clickable {
                // Show people who reacted
                println("reactions ${reactions}")
            },
    ) {
        LazyRow(
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalAlignment = Alignment.CenterVertically,
        ) {
            reactions.forEach { reaction ->
                val emoji = reaction.key ?: return@forEach
                item {
                    Text(
                        emoji,
                        color = if (getReact(reaction.key) == MessageReact.Heart) Color.Red else Color.Unspecified,
                    )
                }
            }

            if (reactions.size > 1 || reactions.map { it.value.size }.sum() > 1)
                item {
                    Text(
                        "${if (reactions.size > 1) reactions.size else reactions.map { it.value.size }.sum()}",
                        style = MaterialTheme.esTypography.c1Medium13.copy(color = Color.White),
                    )
                }
        }
    }
}